import { useEffect, useRef } from "react";
function usePrevious(value, clean = false) {
    const previousValue = useRef();
    useEffect(() => {
        previousValue.current = value;
        return clean
            ? () => {
                previousValue.current = undefined;
            }
            : undefined;
    }, [clean, value]);
    return previousValue.current;
}
export default usePrevious;
